import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Moment from 'moment';

import {
  OrderHistoryH2,
  CitTable,
  OrderHistoryText,
  OrderTH,
} from '../../components/HelperComponents/StyledComponents';

import {
  BulmaSection,
} from '../../components/HelperComponents/HelperComponents';

import {
  stripUrlQueryParams,
} from '../../helpers';

import {
  requestOrderHistory,
} from '../../actions/OrderHistoryActions';

class OrderHistoryComponent extends Component {
  componentDidMount() {
    this.props.dispatch(requestOrderHistory(this.props.user.data.token));
  }

  render() {
    const covers = this.props.orderHistory.items;
    const orders = covers.map((ord, i) => {
      let orderDate = Moment(ord.date_created).format('MM-DD-YY').toString()
      return (
        <Fragment key={`order_${i}`}>
          {/* <tr>
            <td colSpan="8" className="has-text-white">
              <OrderHistoryH2 className="has-text-centered">Order Request {ord.order_key.replace('wc_order_', '#')}: {orderDate}</OrderHistoryH2>
            </td>
          </tr> */}
          {ord.line_items.map((item, i) => {
            return (
              <tr key={`order_line_items_${i}`}>
                <td className="is-narrow">
                  {ord.order_key.replace('wc_order_', '')}
                </td>

                <td className="is-hidden-tablet">
                  <section className="columns is-mobile is-variable is-1">
                    <section className="column is-narrow">
                      <figure className="image is-square is-inline-block" style={{ width: '28px' }}>
                        {item.product_album.albumn_cover ? <img src={stripUrlQueryParams(item.product_album.albumn_cover.url)} style={{ borderRadius: '5px' }} alt="" /> : <div>No Image</div>}
                      </figure>
                    </section>
                    <section className="column is-narrow">
                      <OrderHistoryText theme={{ fontSize: '15px' }}>{item.product_album.post_title}</OrderHistoryText>
                      <OrderHistoryText theme={{ fontSize: '14px' }}>{item.product_album.post_title}</OrderHistoryText>
                      <OrderHistoryText theme={{ fontSize: '14px' }}>{item.product_genre ? item.product_genre.map((gen, i) => gen.post_title) : 'Default Genre'}</OrderHistoryText>
                    </section>
                  </section>
                </td>

                <td className="is-hidden-mobile">
                  <figure className="image is-inline-block" style={{ width: '31px', height: '29px' }}>
                    {item.product_album.albumn_cover ? <img src={stripUrlQueryParams(item.product_album.albumn_cover.url)} style={{ borderRadius: '5px' }} alt="" /> : <div>No Image</div>}
                  </figure>
                </td>
                <td className="is-hidden-mobile">
                  <p className="is-inline">{item.name}</p>
                </td>
                <td className="is-hidden-mobile">{item.product_album.post_title}</td>
                <td className="is-hidden-mobile">{item.product_genre ? item.product_genre.map((gen, i) => gen.post_title) : 'Default Genre'}</td>
                <td className="is-hidden-mobile">{item.product_tempo ? item.product_tempo.map((temp, i) => temp.post_title) : 'Default Tempo' }</td>
                <td className="">{orderDate}</td>
              </tr>
            )
          })}
        </Fragment>
      );
    });

    return (
      <Fragment>
        <BulmaSection columnsClassName="is-multiline">
          <section className="column is-full">
            <OrderHistoryH2>Order Request Tracks</OrderHistoryH2>
          </section>

          <section className="column is-full">
            <CitTable className="table is-fullwidth" theme={{ tableRowBackgroundColor: '#191919' }}>
              <thead>
                <tr>
                  <OrderTH>Order request number</OrderTH>
                  <OrderTH className="is-narrow is-hidden-mobile" />
                  <OrderTH>Title</OrderTH>
                  <OrderTH className="is-hidden-mobile">Album Name</OrderTH>
                  <OrderTH className="is-hidden-mobile">Genre</OrderTH>
                  <OrderTH className="is-hidden-mobile">Tempo</OrderTH>
                  <OrderTH>Request Date</OrderTH>
                </tr>
              </thead>
              <tbody>
                {orders}
              </tbody>
            </CitTable>
          </section>
        </BulmaSection>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user, orderHistory } = state;

  return {
    user,
    orderHistory,
  };
}

export const OrderHistory = connect(mapStateToProps)(OrderHistoryComponent);



// WEBPACK FOOTER //
// ./src/routes/OrderHistory/OrderHistory.js